import React, { useState } from 'react'
import { AlertContext } from './alertContext'
import AlertMgmt from './alert-mgmt'
import Layout from '../layout/layout'
import ALertDetails from './alertDetails'

const AlertView = () => {
  const [viewDetails, setViewDetails] = useState(false)
  const [template, setTemplate] = useState({})
  const [customerId, setCustomerId] = useState('')
  return (
    <>
      <Layout>
        <AlertContext.Provider
          value={{
            viewDetails,
            setViewDetails,
            template,
            setTemplate,
            customerId,
            setCustomerId,
          }}
        >
          {viewDetails ? <ALertDetails /> : <AlertMgmt />}
        </AlertContext.Provider>
      </Layout>
    </>
  )
}

export default AlertView
